import { html } from "lit-html";
import { panelResize } from "./panel-resize";

const statsNav = ({selector, onToggle, onResize}) => html`
  <fieldset class="panel-selector">
    <p>Statistics</p>
    <label for="metric-cases"><input @change=${onToggle} name="metric" id="metric-cases" type="radio" checked>Cases</label>
    <label for="metric-deaths"><input @change=${onToggle} name="metric" id="metric-deaths" type="radio">Deaths</label>
  </fieldset>
  <fieldset class="panel-selector">
    <p>Frequency</p>
    <label for="frequency-total"><input @change=${onToggle} name="frequency" id="frequency-total" type="radio" checked>Total</label>
    <label for="frequency-new"><input @change=${onToggle} name="frequency" id="frequency-new" type="radio">New</label>
  </fieldset>
  <fieldset class="panel-selector">
    <p>Count</p>
    <label for="count-per_million"><input @change=${onToggle} id="count-per_million" type="checkbox">Per million</label>
  </fieldset>
  ${panelResize(onResize)}
`;

export {
  statsNav
}
